export default "__VITE_ASSET__9d9e01b3__"